<template>
  <div class="success">
    <div v-if="showSuccess === 'reject'" class="flex flex-col items-center">
      <iconpark-icon name="circle-success" size="56"></iconpark-icon>
      <div class="text-font-1 text-[20px] mt-[16px]">
        {{ $t('ti-jiao-cheng-gong') }}
      </div>
      <div class="text-font-60 text-14 mt-[10px]">
        {{ $t('gan-xie-nin-de-zhi-chi') }}
      </div>
      <a-button size="large" type="primary" class="mt-[30px]" @click="emits('back')">
        {{ $t('guan-bi-ye-mian') }}
      </a-button>
    </div>
    <div v-else class="flex flex-col items-center">
      <iconpark-icon name="circle-success" size="56"></iconpark-icon>
      <div class="text-font-1 text-[20px] mt-[16px]">
        {{ $t('qian-shu-wan-cheng') }}
      </div>
      <div class="text-font-60 text-14 mt-[10px]">
        {{
          sigeInfo?.reward_coin
            ? $t('gan-xie-nin-de-zhi-chi-yi-wei-nin-zi-dong-fa-fang-x-yan-bi-jiang-li', [
                sigeInfo?.reward_coin,
              ])
            : $t('gan-xie-nin-de-zhi-chi')
        }}
      </div>
      <div v-if="sigeInfo?.reward_coin_expire_days" class="text-font-60 text-14 mt-[10px]">
        {{
          $t('you-xiao-qi-x-tian-qing-zai-you-xiao-qi-nei-shi-yong', [
            sigeInfo?.reward_coin_expire_days,
          ])
        }}
      </div>
      <a-button size="large" type="primary" class="mt-[30px]" @click="emits('back')">
        {{ $t('guan-bi-ye-mian') }}
      </a-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  showSuccess: string;
  sigeInfo: any;
}>();

const emits = defineEmits(['back']);
</script>

<style lang="scss" scoped>
.success {
  @apply flex flex-col h-full items-center justify-center;
}
</style>
